import { HCF, HLocalStorage } from "@macashipo/mlib"

export const sendWebhook = ({ webhookURL, msg, thread } = {}) => {
  if (webhookURL && msg) {
    let _data = {
      text: msg,
    }
    if (thread) {
      webhookURL += `&threadKey=${thread}&messageReplyOption=REPLY_MESSAGE_FALLBACK_TO_NEW_THREAD`
    }
    const data = JSON.stringify(_data)
    let resp
    fetch(webhookURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: data,
    }).then(response => {
      resp = response
      console.log(response)
    })
    return resp
  }
}

export const sendGGNotifyLog = ({
  webhookURL,
  msg,
  force,
  withAgent,
  withUser,
  withUrl,
  withThread,
  withVersion,
  withIp,
} = {}) => {
  let _webHook = webhookURL || HCF.getCF("GGNotifyWebHook")
  if (force !== true && window.location.href.indexOf("localhost") > -1) {
    return null
  }
  let _user = ""
  let _agent = ""
  let _url = ""
  let _version = ""
  let _ip = ""
  let _moreInfo = ""
  if (withAgent || withUser || withUrl) {
    if (withUrl) {
      _url = `\nUrl: ${window.location.href}`
    }
    if (withUser) {
      _user = `\nUser: ${HLocalStorage.getObj("Auth-Info", {}).user_name}`
    }
    if (withAgent) {
      _agent = `\nAgent: ${navigator.userAgent}`
    }
    if (withVersion) {
      _version = `\nVersion: ${process.env["REACT_APP_BUILD_VERSION"]}`
    }
    if (withIp && window._clientIP) {
      _ip = `\nClientIP: ${window._clientIP}`
    }
    _moreInfo = "```" + _url + _user + _agent + _version + _ip + "```"
  }
  if (_webHook) {
    let _msg =
      `From: ${window.location.href}\n` + _moreInfo + `\n` + "```" + msg + "```"
    sendWebhook({
      webhookURL: _webHook,
      msg: _msg,
      thread: withThread,
    })
  }
}
